import { addDays, endOfMonth, format, startOfMonth, subDays } from "date-fns";
import DatePicker from "./DatePicker";
import { formatDateForAPI, formatDateForDisplay, toDate } from "@shared/datetime/dateUtils";

const DEFAULT_PRESETS = [
  {
    label: "Last 7 days",
    getRange: () => ({ startDate: formatDateForAPI(subDays(new Date(), 6)), endDate: formatDateForAPI(new Date()) }),
  },
  {
    label: "This month",
    getRange: () => ({ startDate: formatDateForAPI(startOfMonth(new Date())), endDate: formatDateForAPI(endOfMonth(new Date())) }),
  },
  {
    label: "Last 30 days",
    getRange: () => ({ startDate: formatDateForAPI(subDays(new Date(), 29)), endDate: formatDateForAPI(new Date()) }),
  },
];

export default function DateRangePicker({
  startDate,
  endDate,
  onChange,
  minDate,
  maxDate,
  disabledWeekdays,
  disabledDates,
  presets = true,
  className = "",
}) {
  const updateStart = (dateKey) => {
    const end = toDate(endDate);
    const nextStart = toDate(dateKey);
    onChange?.({
      startDate: dateKey,
      endDate: end && nextStart && end < nextStart ? dateKey : endDate,
    });
  };

  const updateEnd = (dateKey) => {
    const start = toDate(startDate);
    const nextEnd = toDate(dateKey);
    onChange?.({
      startDate: start && nextEnd && start > nextEnd ? dateKey : startDate,
      endDate: dateKey,
    });
  };

  const presetList = Array.isArray(presets) ? presets : presets ? DEFAULT_PRESETS : [];

  return (
    <div className={className}>
      {presetList.length ? (
        <div className="mb-4 flex flex-wrap gap-2">
          {presetList.map((preset) => (
            <button
              key={preset.label}
              type="button"
              onClick={() => onChange?.(preset.getRange())}
              className="rounded-full border border-[#DED7CC] bg-white px-4 py-2 text-sm font-bold text-[#224032] transition hover:bg-[#E9EEE7]"
            >
              {preset.label}
            </button>
          ))}
        </div>
      ) : null}

      <div className="mb-4 grid gap-3 rounded-2xl border border-[#DED7CC] bg-white p-3 text-sm text-[#64756D] sm:grid-cols-2">
        <div>
          <span className="font-bold text-[#224032]">Start</span>
          <p>{formatDateForDisplay(startDate) || "Choose start date"}</p>
        </div>
        <div>
          <span className="font-bold text-[#224032]">End</span>
          <p>{formatDateForDisplay(endDate) || "Choose end date"}</p>
        </div>
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        <DatePicker
          selectedDate={startDate}
          onSelect={updateStart}
          minDate={minDate}
          maxDate={maxDate}
          disabledWeekdays={disabledWeekdays}
          disabledDates={disabledDates}
        />
        <DatePicker
          selectedDate={endDate || formatDateForAPI(addDays(toDate(startDate) || new Date(), 1))}
          onSelect={updateEnd}
          minDate={startDate || minDate}
          maxDate={maxDate}
          disabledWeekdays={disabledWeekdays}
          disabledDates={disabledDates}
        />
      </div>
    </div>
  );
}
